export enum NoteOwnerTypes {
  Insured = 0,
  Agent = 1,
  Agency = 2,
  Policy = 3,
  Task = 4,
  Opportunity = 5,
  Claim = 6,
  ServiceRequest = 7,
  SuperUserAgencyNotes = 8,
}
